import IconsList from "./IconsList.jsx";
import { MdOpenInNew } from "react-icons/md";
import ContactBandBtnLogic from "./ContactBandBtnLogic.jsx";
import LikeSection from "../utils/LikeSection.jsx";
import FollowSection from "../utils/FollowSection.jsx";
import artistFallback from "../../assets/fallback/artist_fallback.webp";

const city = "Strängnäs";

const BasicProfileInfoCard = ({
  name,
  profileImage,
  active,
  homepage,
  mail,
  constalation,
  streamingplatfoms,
  socials,
  likes,
  followers,
}) => {
  return (
    <div className="flex flex-col gap-6 w-full">
      {/* Profile Image & Like/Follow Buttons on the same row */}
      <div className="flex items-center gap-4 w-full px-1">
        <div className="pt-2">
          <img
            src={profileImage ? profileImage : artistFallback}
            alt={`${name}´s profile image`}
            className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-full border border-base-content/10 shadow-md shrink-0"
          />
        </div>
        <div className="flex gap-1 flex-wrap items-center mt-[-1.2rem]">
          <LikeSection likes={likes} />
          <FollowSection followers={followers} />
        </div>
      </div>

      {/* Profil Info Card */}
      <div className="rounded-2xl border border-base-content/10 bg-base-200 p-6 shadow-sm">
        <p className="text-blue-500 text-xs font-bold tracking-wider uppercase mb-5">
          Profil info
        </p>
        
        <div className="flex flex-col gap-1 mb-6">
          {/* ORT */}
          <div className="flex justify-between items-center py-3.5 border-b border-base-content/5">
            <span className="text-xs font-bold text-base-content/45 uppercase tracking-wider">ORT</span>
            <span className="text-sm font-extrabold text-white">{city}</span>
          </div>

          {/* TYP */}
          <div className="flex justify-between items-center py-3.5 border-b border-base-content/5">
            <span className="text-xs font-bold text-base-content/45 uppercase tracking-wider">TYP</span>
            <span className="text-sm font-extrabold text-white capitalize">{constalation || "Band"}</span>
          </div>

          {/* AKTIV */}
          <div className="flex justify-between items-center py-3.5 border-b border-base-content/5">
            <span className="text-xs font-bold text-base-content/45 uppercase tracking-wider">AKTIV</span>
            <span className="text-sm font-extrabold text-white flex items-center gap-2">
              <span className={`w-2.5 h-2.5 rounded-full ${active ? "bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.6)]" : "bg-neutral-500"}`}></span>
              {active ? "Ja" : "Nej"}
            </span>
          </div>

          {/* GIGGAR */}
          <div className="flex justify-between items-center py-3.5">
            <span className="text-xs font-bold text-base-content/45 uppercase tracking-wider">GIGGAR</span>
            <span className="text-sm font-extrabold text-white">
              {active ? "Ja" : "Nej"}
            </span>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex flex-col gap-3">
          {homepage && (
            <a href={homepage} target="_blank" rel="noopener" className="block w-full">
              <button className="btn btn-primary w-full flex items-center justify-center gap-2 text-sm font-bold shadow-md">
                Hemsida <MdOpenInNew size={16} />
              </button>
            </a>
          )}
          {mail && <ContactBandBtnLogic mail={mail} />}
        </div>
      </div>

      {/* Streama & Socials Card */}
      {(streamingplatfoms || socials) && (
        <div className="rounded-2xl border border-base-content/10 bg-base-200 p-6 shadow-sm">
          {streamingplatfoms && Object.keys(streamingplatfoms).some(k => streamingplatfoms[k]) && (
            <div className="mb-6">
              <p className="text-blue-500 text-xs font-bold tracking-wider uppercase mb-4">STREAMA</p>
              <IconsList data={streamingplatfoms} />
            </div>
          )}
          
          {socials && Object.keys(socials).some(k => socials[k]) && (
            <div>
              <p className="text-blue-500 text-xs font-bold tracking-wider uppercase mb-4">SOCIALS</p>
              <IconsList data={socials} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BasicProfileInfoCard;
